import React, { useState } from 'react';
import { Route, Switch } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Footer from './Footer';
import Header from './Header';
import { LinksPageApp } from '@nutastic/nutastic-react-app/src/components/packs/index';
import { AppContainer, useAppState } from '@nutastic/nutastic-react-app';

const App = () => {
    const { linksPageConfig } = useAppState();
    const [showLinksPage, setShowLinksPage] = useState(false);
    const renderPageRoute = () => {
        return <Switch>
            <Route path={['/', '/home']} component={HomePage}/>
        </Switch>;
    };

    const onToggleLinksPageClick = () => setShowLinksPage(!showLinksPage);

    return <AppContainer>
        <Header onToggleLinksPage={onToggleLinksPageClick} linksPageIsActive={showLinksPage} />
        { renderPageRoute() }
        <Footer />
        { (linksPageConfig && showLinksPage) && <LinksPageApp {...linksPageConfig} /> }
    </AppContainer>;
};

export default App;
